import { ADDTOCART } from "./actionIdentifier";
export const addToCart = (id, product) => {
  return {
    type: ADDTOCART,
    payload: {
      id,
      product,
    },
  };
};
